export default "__VITE_ASSET__CXnfp2Sd__"